import { SVGProps } from 'react'
const CopyIcon = ({ className, ...props }: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    width={36}
    height={36}
    className={className}
    {...props}
  >
    <path
      d="M5.5 29V11.5c0-.8.7-1.5 1.5-1.5s1.5.7 1.5 1.5v16h16c.8 0 1.5.7 1.5 1.5s-.7 1.5-1.5 1.5H7c-.8 0-1.5-.7-1.5-1.5zm5-5V6.5c0-.8.7-1.5 1.5-1.5h17.5c.8 0 1.5.7 1.5 1.5V24c0 .8-.7 1.5-1.5 1.5H12c-.8 0-1.5-.7-1.5-1.5zm3-1.5H28V8H13.5v14.5z"
      style={{
        fill: '#fff',
      }}
    />
  </svg>
)
export default CopyIcon
